import { useEffect, useState } from 'react'
import { Button } from '@/components/ui'

const entry = (html: string) => html.match(/\/assets\/index-[\w-]+\.js/)?.[0] ?? null

/**
 * Say so when the dashboard was deployed since this tab loaded. A tab left
 * open runs the old code for days, and fixed problems looked unfixed.
 */
export function NewVersion() {
  const [stale, setStale] = useState(false)
  useEffect(() => {
    const mine = [...document.scripts].map((s) => s.src.match(/\/assets\/index-[\w-]+\.js/)?.[0]).find(Boolean)
    if (!mine) return
    const check = () => void fetch('/', { cache: 'no-store' }).then((r) => r.text()).then((h) => { const cur = entry(h); if (cur && cur !== mine) setStale(true) }, () => {})
    const t = setInterval(check, 60_000)
    const vis = () => { if (document.visibilityState === 'visible') check() }
    document.addEventListener('visibilitychange', vis)
    return () => { clearInterval(t); document.removeEventListener('visibilitychange', vis) }
  }, [])
  if (!stale) return null
  return (
    <div role="status" className="fixed right-4 bottom-4 z-50 flex items-center gap-3 rounded-md border border-border bg-surface-2 px-3 py-2 text-sm shadow-lg">
      A new version of the dashboard is out.
      <Button size="sm" variant="primary" onClick={() => location.reload()}>Reload</Button>
    </div>
  )
}
